import React, { useState, useEffect } from 'react';
import OutputType from './ComponentsTpes/OutputType';

const Lock = ({ selectedType, fieldsData, componentSourceOptions, selectedPorts, setSelectedPorts,
    savedData, setSavedData
}) => {
    const selectOptions = (key, value) => {
        setSavedData(prevData => {
            return {
                ...prevData,
                Lock: {
                    ...prevData.Lock,
                    [key]: value
                }
            }
        })
    }

    return <OutputType
        selectedPorts={selectedPorts}
        setSelectedPorts={setSelectedPorts}
        source={componentSourceOptions?.outputsData}
        selectOptions={selectOptions}
        component_source={savedData.Lock.component_source.value}
        condition={savedData.Lock.condition}
        output={savedData.Lock.output}
        name={savedData.Lock.name}
        relay_mode={savedData.Lock.relay_mode}
        impulse_time={savedData.Lock.impulse_time}
        entry_exit_open_durations={savedData.Lock.entry_exit_open_durations}
        sensorAutolock={savedData.Lock.sensorAutolock}
        fieldsData={fieldsData}
    />
}

export default Lock;